import { render } from "./CheckoutAdminSuccess.vue?vue&type=template&id=bf3fd04c"
import script from "./CheckoutAdminSuccess.vue?vue&type=script&lang=js"
export * from "./CheckoutAdminSuccess.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__